import { TableContainer, Table, TableHead, TableRow, TableCell, TableBody, makeStyles, Button  } from "@material-ui/core";
import { Link, menuHelper, PortalContext } from "@portal/arq-portal-core"
import React from "react";

const useStyles = makeStyles({
    InfoUsuario:{
        textAlign: 'center', 
        padding: '2%',
        '& h3': {
            color:'#606060',
            fontFamily: 'CO-Bold',
            borderBottom: '1px solid #919191',
            marginBottom: '0px',
            paddingBottom: '20px',
            fontSize: '16px',
        },
        '@media screen and (max-width: 1250px)': {
            '& .MuiTableHead-root': {
                display: "none",
            },
            '& td.MuiTableCell-root.MuiTableCell-body': {
                display: "block",
            },
            '& td.MuiTableCell-root.MuiTableCell-body:before': {
                 content: 'attr(data-headcell) ": "',
                 fontWeight: 'bold',
                 color: '#DC0028',
                 float: 'left',
                 minWidth: '100px'
            },
        },
    },
    InfoTable:{
        textAlign: 'center', 
        width: 'calc(33.3% - 30px)',
        padding: '30px',
        '@media screen and (max-width: 1250px)': {
            width: 'calc(100% - 30px)',
            padding: '15px',
        },
        '& h3': {
            color:'#606060',
            fontFamily: 'CO-Bold',
            borderBottom: '1px solid #919191',
            marginBottom: '0px',
            paddingBottom: '20px',
            fontSize: '16px',
        },
        //border:'2px solid black'
    },
    TableContainer:{
        display:'flex',
        flexDirection: 'row',
        '@media screen and (max-width: 1250px)': {
            display: 'block',
        },
        //border:'2px solid black'
        marginBottom: "20px"
    },
    Cabecera:{
        fontWeight: 'bold', 
        borderColor: '#919191', 
        color: '#dc0028'
    }
});

export const InfoMenu = (props:any) => {

    const classes = useStyles(props);

    let url = props.url??window.location.pathname.substring(6);

    const {menu} = React.useContext(PortalContext);

    const menuOption = menuHelper.getMenuOption(menu, url)

    return <div className={classes.InfoUsuario}>
    <h3>Información del punto de menú</h3>
    <TableContainer className={classes.TableContainer}>
        <Table>
            <TableHead>
                <TableRow>
                   <TableCell className = {classes.Cabecera}>Identificador</TableCell>
                   <TableCell className = {classes.Cabecera}>Titulo</TableCell>
                   <TableCell className = {classes.Cabecera}>Icono</TableCell>
                   <TableCell className = {classes.Cabecera}>Plantilla</TableCell>
                   <TableCell className = {classes.Cabecera}>Tipo</TableCell>
                   <TableCell className = {classes.Cabecera}>UrlApp</TableCell>
                   <TableCell className = {classes.Cabecera}>Abrir en popup</TableCell>
                   <TableCell className = {classes.Cabecera}>Oculto</TableCell>
                </TableRow>
            </TableHead>
            <TableBody>
                <TableRow>
                   <TableCell data-headcell={"Titulo"}>{menuOption?.id}</TableCell>
                   <TableCell data-headcell={"Titulo"}>{menuOption?.titulo}</TableCell>
                   <TableCell data-headcell={"Icono"}>{menuOption?.icono}</TableCell>
                   <TableCell data-headcell={"Plantilla"}>{menuOption?.plantilla}</TableCell>
                   <TableCell data-headcell={"Tipo"}>{menuOption?.tipo}</TableCell>
                   <TableCell data-headcell={"UrlApp"}>{menuOption?.urlApp}</TableCell>
                   <TableCell data-headcell={"Abrir en popup"}>{menuOption?.popup ? "Sí" : "No"}</TableCell>
                   <TableCell data-headcell={"Oculto"}>{menuOption?.oculto ? "Sí" : "No"}</TableCell>   
                </TableRow>
                </TableBody>
            </Table>
        </TableContainer>
        {/* {menuOption?.id !== null && <Button component={Link} to={"/aplicacion/?aplicacion=AplicacionesGCO&urlTransaccion="+encodeURIComponent("FE/ARQ.Portal.Menu.FE.DetalleMenu/?CodOpcioMenu=" + menuOption?.id)} variant="outlined" color="primary">Modificar</Button>} */}
        {menuOption?.id !== null && <Button component={Link} to={"/aplicacion/?aplicacion=AplicacionesGCO&urlTransaccion=FE/ARQ.Portal.Menu.FE.BusquedaMenu/?Identificador=" + menuOption?.id} variant="outlined" color="primary">Modificar</Button>}
    </div>
}